import React, { useState, useEffect, useRef, useInsertionEffect } from 'react'
import Slider from 'react-slick'
import Episode from './Episode'
import TrackData from './TrackData'
import subjects from '~/comm'
import { connect } from 'react-redux'
import {
	selectProgramSlug, fetchProgramIfNeeded, programEpisodeWithPlaylist, programEpisodes, programEpisodesWithCurrentPlaylist, fetchEpisodesIfNeeded, fetchEpisodeIfNeeded, selectEpisodeDate
} from '../actions'



const Show = (props) => {

	let { match, history, dispatch, selectedProgramSlug, selectedEpisodeDate, programs } = props

	const showEps = useRef(null);

	let [ episodeKey, setEpisodeKey ] =  useState(null);

	useInsertionEffect( () => { 
		const body = document.getElementsByTagName('body')[0];
		body.className = 'show';
		return () => { 
			if(body.className === 'show')
				body.className = '';
		}
	}, [])

	useEffect( () => { //DID MOUNT
		subjects.episode.subscribe(x => {
			if (x === 'next') {
				setEpisodeKey(episodeKey => episodeKey + 1)
			} else if (x === 'prev') {
				setEpisodeKey(episodeKey => episodeKey - 1)
			}
		});
		dispatch(selectProgramSlug(match.params.id));
		if(match.params.date) {
			//dispatch(selectEpisodeDate(match.params.date))
			dispatch(programEpisodes(match.params.id)).then(() =>
				dispatch(programEpisodeWithPlaylist(match.params.id, match.params.date))
			)
		}
		else {
			//dispatch(fetchProgramIfNeeded(match.params.id))
			dispatch(selectEpisodeDate(null));
			dispatch(programEpisodesWithCurrentPlaylist(match.params.id));
		}


		return function cleanup() {
			subjects.episode.unsubscribe
		}
	}, []);

	useEffect( () => {
		const { match, history, dispatch } = props
		console.log('about to mount')
		dispatch(selectProgramSlug(match.params.id))
		if(match.params.date) {
			//dispatch(selectEpisodeDate(match.params.date))
			dispatch(programEpisodes(match.params.id)).then(() =>
				dispatch(programEpisodeWithPlaylist(match.params.id, match.params.date))
			)
		}
		else {
			//dispatch(fetchProgramIfNeeded(match.params.id))
			dispatch(selectEpisodeDate(null))
			dispatch(programEpisodesWithCurrentPlaylist(match.params.id))
		}
		//dispatch(fetchProgramIfNeeded(match.params.id))
		//dispatch(fetchEpisodesIfNeeded(match.params.id))
	}, [ match.params] );

	useEffect( () => {
		if (selectedProgramSlug && selectedEpisodeDate ) {
			let episodes = programs[selectedProgramSlug].episodes
			if ( episodes.episodeIndex ) {
				setEpisodeKey( episodes.episodeIndex.findIndex((item) => item === decodeURI(selectedEpisodeDate)	) )

			} else {
				setEpisodeKey(null);
			}
		}
		else {
			setEpisodeKey(null);
		}
	}, [ selectedProgramSlug, selectedEpisodeDate ] );

	useEffect( () => {
		if (showEps.current)
			showEps.current.slickGoTo(episodeKey);
	}, [episodeKey] );

	const getEpisode = (episodeKey) => {
		if(selectedProgramSlug && programs[selectedProgramSlug]  && programs[selectedProgramSlug].episodes && programs[selectedProgramSlug].episodes &&  programs[selectedProgramSlug].episodes.episodeIndex && programs[selectedProgramSlug].episodes.episodeIndex[episodeKey] ) {
			let episodes = programs[selectedProgramSlug].episodes
			dispatch(selectEpisodeDate(episodes.episodeIndex[episodeKey]))
			//dispatch(setCurrentEpisode(selectedProgramSlug, episodes[episodes.episodeIndex[episodeKey]], episodeKey))
			history.push('/program/'+selectedProgramSlug+'/'+episodes.episodeIndex[episodeKey] )
			if (episodes !== null) {
				if(showEps) {
					console.log(episodeKey)
					showEps.current.slickGoTo(episodeKey)
				}
			}
		}
	}

	// const { programs, selectedProgramSlug, selectedEpisodeDate } = this.props
	if ( programs && selectedProgramSlug && programs[selectedProgramSlug]) {
		let program = programs[selectedProgramSlug]
		//console.log(program)
	}

	let ep = null;

	const selectedProgram = (programs && selectedProgramSlug && programs[selectedProgramSlug] ) ? programs[selectedProgramSlug] : null
	const program = (selectedProgram && selectedProgram.program && selectedProgram.program.xhr === 'FETCHED') ? selectedProgram.program : null
	const episodes = (selectedProgram && selectedProgram.episodes && selectedProgram.episodes.xhr === 'FETCHED') ? selectedProgram.episodes : null
	const episode = (selectedProgram && selectedProgram.episodes && selectedProgram.episodes.xhr === 'FETCHED' && selectedProgram.episodes[selectedEpisodeDate] ) ? selectedProgram.episodes[selectedEpisodeDate] : null
	const currentPlaylist = selectedEpisodeDate ? selectedEpisodeDate : null
	const playlist = (selectedProgram && selectedProgram.playlists && currentPlaylist && selectedProgram.playlists[currentPlaylist] && selectedProgram.playlists[currentPlaylist].xhr === 'FETCHED') ? selectedProgram.playlists[currentPlaylist] : null

	if ( selectedProgram && program && episodes && episode && currentPlaylist ) {
		let episodeKey = episodes.episodeIndex.indexOf(selectedEpisodeDate)
		let image = null;
		if (episode.imageUrl !== null) {
			image = episode.imageUrl;
		}
		else if (program.bannerImageUrl != null ) {
			image = program.bannerImageUrl;
		}
		else {
			image = program.profileImageUrl;
		}

		const slider = episodes.episodeIndex.map((item, index) => {
			let image = null;
			if (episodes[item].imageUrl !== null) {
				image = episodes[item].imageUrl;
			}
			else if (program.bannerImageUrl != null ) {
				image = program.bannerImageUrl;
			}
			else {
				image = program.profileImageUrl;
			}
			return (
				<div  key={index}>
					<div className="episode-image" style={{ backgroundImage: 'url(' +  image + ')' }}></div>
				</div>
			)
		}

		)
		var settings = {
			dots: false,
			arrows: true,
			infinite: true,
			speed: 200,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			initialSlide: episodeKey,
			afterChange: function(event) {
				getEpisode(event)
			}
		}

		ep = (
			<div>
				<div className="show-list">
					<Slider ref={showEps} {...settings}>
						{slider}
					</Slider>
				</div>
				<div className="show-info">
					<div className="content">
						<div className="program-notes">
							<Episode index={{position: episodeKey, total: episodes.episodeIndex.length}} episode={episode} program={program}></Episode>
							<TrackData style={{pointerEvents: 'all'}} episode={episode}
							playlist={playlist} program={props.programs[props.selectedProgramSlug]}></TrackData>
						</div>
					</div>
				</div>
			</div>
		)
	}
	else {
		ep = (
			<div className="spinner-wrapper">
				<div className="spinner"></div>
			</div>
		)
	}

	return (
		<div>
			{ep}
			<div id="custom-show">
			</div>
		</div>
	)
}

Show.fetchData = (store, route, match) => {
	if(match.params.date) {
		return Promise.all([
			store.dispatch(selectProgramSlug(match.params.id)),
			store.dispatch(programEpisodes(match.params.id)).then(() =>
				store.dispatch(programEpisodeWithPlaylist(match.params.id, match.params.date))
			)
		])
	}
	else {
		return Promise.all([
			store.dispatch(selectProgramSlug(match.params.id)),
			store.dispatch(selectEpisodeDate(null)),
			store.dispatch(programEpisodesWithCurrentPlaylist(match.params.id))
		])
	}
}

export default connect(state => ({ programs: state.programs, selectedProgramSlug: state.selectedProgramSlug, selectedEpisodeDate: state.selectedEpisodeDate }))(Show)
